/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PremiumDueReinsuredOptionDto
 */
export interface PremiumDueReinsuredOptionDto {
    /**
     * 
     * @type {string}
     * @memberof PremiumDueReinsuredOptionDto
     */
    reinsuredId: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumDueReinsuredOptionDto
     */
    name: string;
}

/**
 * Check if a given object implements the PremiumDueReinsuredOptionDto interface.
 */
export function instanceOfPremiumDueReinsuredOptionDto(value: object): value is PremiumDueReinsuredOptionDto {
    if (!('reinsuredId' in value) || value['reinsuredId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function PremiumDueReinsuredOptionDtoFromJSON(json: any): PremiumDueReinsuredOptionDto {
    return PremiumDueReinsuredOptionDtoFromJSONTyped(json, false);
}

export function PremiumDueReinsuredOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PremiumDueReinsuredOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'reinsuredId': json['reinsuredId'],
        'name': json['name'],
    };
}

export function PremiumDueReinsuredOptionDtoToJSON(json: any): PremiumDueReinsuredOptionDto {
    return PremiumDueReinsuredOptionDtoToJSONTyped(json, false);
}

export function PremiumDueReinsuredOptionDtoToJSONTyped(value?: PremiumDueReinsuredOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reinsuredId': value['reinsuredId'],
        'name': value['name'],
    };
}

